import { gql } from "@apollo/client";

export const CREATE_MIS_TAREAS = gql`
    mutation CreateMisTareas(
        $input: AddMisTareasInput!
    ) {
        createMisTareas(
            input: $input
        ) {
            idDatosGeneralesRI
            idProfesional
            fechaLimite
        }
    }
`;